import { getSessionTeamType } from './getTeamType';

export const isInventoryAnalyst = () => getSessionTeamType() === 'Inventory Analyst';
